import { P00039DataRxTxIndex } from '../../../P00039Sync';
import { getPoolMasterClass } from '../../../../../ECoSystemsHelper';
import { P00041 } from '../../../P00041';
import { P00042 } from '../../../P00042';
import { IProduct } from '../../../../IProduct';
import { P00032 } from '../../../P00032';
import { P00030 } from '../../../P00030';
import { P00058 } from '../../../P00058';
import { Pool } from '../../../../../../../apis/pool.api';

export function P00058PompeMiseEnOeuvreInit(
  pool: Pool,
  productClass: IProduct,
  editValue: any,
  getValue: any,
): boolean {
  const master = getPoolMasterClass(pool);

  const presenceProduitP00032 = master?.hasProduct(pool, new P00032()) ?? 0;
  const presenceProduitP00030 = master?.hasProduct(pool, new P00030()) ?? 0;

  const previousValueHorsGel = getValue(
    'pvISourceTemperatureHorsGel',
    productClass,
  );

  if (presenceProduitP00032 > 0 && presenceProduitP00030 > 0) {
    editValue(
      P00039DataRxTxIndex.PompeVS_Installation,
      'pvISourceTemperatureHorsGel',
      0,
      null,
      productClass,
    );
  } else if (presenceProduitP00032 > 0) {
    editValue(
      P00039DataRxTxIndex.PompeVS_Installation,
      'pvISourceTemperatureHorsGel',
      0,
      null,
      productClass,
    );
  } else if (presenceProduitP00030 > 0) {
    editValue(
      P00039DataRxTxIndex.PompeVS_Installation,
      'pvISourceTemperatureHorsGel',
      1,
      null,
      productClass,
    );
  } else {
    editValue(
      P00039DataRxTxIndex.PompeVS_Installation,
      'pvISourceTemperatureHorsGel',
      0,
      null,
      productClass,
    );
  }

  if (
    previousValueHorsGel !==
    getValue('pvISourceTemperatureHorsGel', productClass)
  ) {
    if (previousValueHorsGel === 1) {
      editValue(
        P00039DataRxTxIndex.PompeVS_Parametrage1,
        'pvPSeuilTemperatureHorsGel',
        3,
        null,
        productClass,
      );
    } else {
      editValue(
        P00039DataRxTxIndex.PompeVS_Parametrage1,
        'pvPSeuilTemperatureHorsGel',
        0,
        null,
        productClass,
      );
    }
  }

  editValue(
    P00039DataRxTxIndex.PompeVS_Installation,
    'pvISourceTemperature24',
    0,
    null,
    productClass,
  );

  const presenceProduitP00041 = master?.hasProduct(pool, new P00041()) ?? 0;
  const presenceProduitP00042 = master?.hasProduct(pool, new P00042()) ?? 0;

  if (presenceProduitP00041 > 0 && presenceProduitP00042 > 0) {
    editValue(
      P00039DataRxTxIndex.PompeVS_Installation,
      'pvISourceVolet',
      1,
      null,
      productClass,
    );
  } else if (presenceProduitP00041 > 0) {
    editValue(
      P00039DataRxTxIndex.PompeVS_Installation,
      'pvISourceVolet',
      2,
      null,
      productClass,
    );
  } else if (presenceProduitP00042 > 0) {
    editValue(
      P00039DataRxTxIndex.PompeVS_Installation,
      'pvISourceVolet',
      1,
      null,
      productClass,
    );
  } else {
    editValue(
      P00039DataRxTxIndex.PompeVS_Installation,
      'pvISourceVolet',
      0,
      null,
      productClass,
    );
  }

  return false;
}
